/**
 * Container for the Badge modal component
 */
import React from 'react'
import { connect } from 'react-redux'
import { Dispatch, AnyAction } from 'redux'
import { toggleBadgeModal } from '../../badges/actions'

export interface Actions {
	toggleBadgeModal: (show: boolean, badgeId: number, shouldBePushedToEarned: boolean, earned: boolean) => void
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): Actions => ({
	toggleBadgeModal: (show: boolean, badgeId: number, shouldBePushedToEarned: boolean, earned: boolean) => {
		dispatch(toggleBadgeModal({ show, badgeId, earned, shouldBePushedToEarned }))
	},
})

export default (Component: React.ComponentType<Actions>) => connect(null, mapDispatchToProps)(Component)
